import { Component, Inject, OnDestroy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/app.state';
import {
  loadGlobalSettingsValueRecognition,
  returnSavedGlobalSettingsValueRecognition,
  updateGlobalSettingsValueRecognition,
} from '../../store/global-settings.actions';
import { selectGlobalSettingsValueRecognitionForm } from '../../store/global-settings.selectors';
import { filter, Subscription } from 'rxjs';
import { FormGroupState } from 'ngrx-forms';
import { openActionDialog } from 'src/app/shared/store/action-dialog/action-dialog.actions';
import { ActionDialogType } from 'src/app/shared/models/enums/action-dialog-type.enum';
import { ValueRecognitionTableInfos } from '../../../common/models/value-recognition-tables-info.model';
import { ValueRecognitionForm } from '../../../common/models/value-recognition-form.model';
import { createValueRecognitionTablesInfo } from '../../../common/helpers/value-recognition-helper';

@Component({
  standalone: false,
  selector: 'app-global-settings-value-recognition-dialog',
  templateUrl: './global-settings-value-recognition-dialog.component.html',
  styleUrls: ['./global-settings-value-recognition-dialog.component.scss'],
})
export class GlobalSettingsValueRecognitionDialogComponent
  implements OnDestroy
{
  readonly = true;
  tablesInfo!: ValueRecognitionTableInfos;
  valueRecognitionFormState: FormGroupState<ValueRecognitionForm> | undefined;

  private readonly subscription = new Subscription();

  constructor(
    private store: Store<AppState>,
    private dialogRef: MatDialogRef<GlobalSettingsValueRecognitionDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {}
  ) {
    this.store.dispatch(loadGlobalSettingsValueRecognition());

    this.subscription.add(
      this.store
        .select(selectGlobalSettingsValueRecognitionForm)
        .pipe(filter((x) => x != null))
        .subscribe((valueRecognitionFormState) => {
          this.valueRecognitionFormState = valueRecognitionFormState;
          this.tablesInfo = createValueRecognitionTablesInfo(
            valueRecognitionFormState
          );
        })
    );
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  closeWindow() {
    this.dialogRef.close();
  }

  edit() {
    this.readonly = false;
  }

  cancel() {
    this.readonly = true;
    this.store.dispatch(returnSavedGlobalSettingsValueRecognition());
  }

  save() {
    this.store.dispatch(
      openActionDialog({
        title: 'confirm saved changes',
        description:
          "Please confirm that you'd like to save these changes because it will affect all of your future projects when calculating the values.",
        confirmButtonText: 'confirm changes',
        dialogType: ActionDialogType.Confirmation,
        onConfirm: () => {
          this.readonly = true;
          this.store.dispatch(updateGlobalSettingsValueRecognition());
        },
      })
    );
  }
}
